import {
	FETCH_APPLINK_FAILURE,
	type FetchAppLinkFailureAction,
} from '../../actions/fetch-applink-failure/index.tsx';
import {
	FETCH_APPLINK_SUCCESS,
	type FetchAppLinkSuccessAction,
} from '../../actions/fetch-applink-success/index.tsx';
import { FETCH_APPLINK, type FetchAppLinkAction } from '../../actions/fetch-applink/index.tsx';
import type { AppLinkState } from './types.tsx';

type AppLinkHandledAction =
	| FetchAppLinkSuccessAction
	| FetchAppLinkFailureAction
	| FetchAppLinkAction;

export const defaultState: AppLinkState = {
	isLoaded: false,
	appLink: undefined,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppLinkState = defaultState, action: AppLinkHandledAction): AppLinkState => {
	switch (action.type) {
		case FETCH_APPLINK: {
			const { error, ...stateWithoutError } = state;
			const newState = {
				...stateWithoutError,
				isLoaded: false,
			};
			return newState;
		}
		case FETCH_APPLINK_SUCCESS:
			return {
				...state,
				isLoaded: true,
				appLink: action.payload,
			};
		case FETCH_APPLINK_FAILURE:
			return {
				...state,
				error: action.payload,
				isLoaded: true,
			};
		default: {
			return state;
		}
	}
};
